import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=075f9717&"
import script from "./CatalogView.vue?vue&type=script&lang=js&"
export * from "./CatalogView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports